import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      width: '50vw',
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 2.5),
    },
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    opacity: 0,
  },

  prizeText: {
    flexFlow: 'inherit',
    flex: '0 0 auto',
    fontSize: `max(${theme.spacing(14)}, min(${theme.spacing(25)}, 6vw))`,
    fontFamily: '"Bebas Neue"',
    letterSpacing: '0.05em',
    lineHeight: 1,

    [theme.breakpoints.down('md')]: {
      fontSize: `max(${theme.spacing(8)}, min(${theme.spacing(15)}, 5vw))`,
    },
  },

  fadeIn: {
    opacity: 1,
    transition: 'opacity 1.5s',
  },

  smallerText: {
    fontSize: `max(${theme.spacing(10)}, min(${theme.spacing(20)}, 5vw))`,

    [theme.breakpoints.down('md')]: {
      fontSize: `max(${theme.spacing(6)}, min(${theme.spacing(13)}, 4vw))`,
    },
  },
}));
